import GetCountries from '@/services/logistics/countryService/GetCountries';
import FindCountryByIso from '@/services/logistics/countryService/findCountryByIso';

export default class CountryService {
    /**
     * Find country by iso.
     *
     * @param {String} iso
     *
     * @returns {Object}
     */
    static findCountryByIso(iso) {
        return (new FindCountryByIso()).handle(iso);
    }

    /**
     * List of countries objects.
     *
     * @returns {Array}
     */
    static getCountries() {
        return (new GetCountries()).handle();
    }
}
